function generateColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';

    for (let i = 0; i < 6; i++) {
        let c = letters[Math.floor(Math.random() * 16)];
        if (c === '#ffffff') {
            generateColor();
        }
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

export const geraCor = () => {
    return generateColor();
}

export const geraCores = (lenght: number) => {
    let cores: string[] = [];
    for (let i = 0; i < lenght; i++) {
        cores.push(
            generateColor()
        );
    }

    return cores;

}